var React = require('react');

function EditColorOutline (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"3","transform":"translate(0.5, 0.5)"},[React.createElement("line",{"data-cap":"butt","data-color":"color-2","fill":"none","stroke":"#444444","strokeWidth":"3","strokeMiterlimit":"10","x1":"53.2","y1":"10.8","x2":"10.8","y2":"53.2","strokeLinejoin":"miter","strokeLinecap":"butt","key":0}),React.createElement("circle",{"fill":"none","stroke":"#444444","strokeWidth":"3","strokeLinecap":"square","strokeMiterlimit":"10","cx":"32","cy":"32","r":"30","strokeLinejoin":"miter","key":1})]));
}

EditColorOutline.defaultProps = {"x":"0px","y":"0px","width":"64px","height":"64px","viewBox":"0 0 64 64"};

module.exports = EditColorOutline;

EditColorOutline.default = EditColorOutline;
